<template>
	<div>
		<CRow>
			<CCol>
				<h3>Caractéristiques</h3>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<CInput
					name="reference"
					label="Numéro de palette"
					:value="pallet ? pallet.reference : null"
					required />
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<vc-date-picker
					v-model="handoverTime"
					:model-config="modelConfig"
					:masks="masks"
					mode="dateTime"
					is24hr>
					<template v-slot="{ inputValue, inputEvents }">
						<input type="hidden" name="handoverTime" :value="inputValue" />
						<CInput
							type="string"
							label="Date de remise"
							description="Exemple: 06/12/2021 09:57"
							:value="$moment(inputValue).format('DD/MM/YYYY HH:mm')"
							v-on="inputEvents">
							<template #append-content>
								<CIcon name="cil-calendar" />
							</template>
						</CInput>
					</template>
				</vc-date-picker>
			</CCol>
		</CRow>
		<hr />
		<CRow>
			<CCol>
				<h3>Limites</h3>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<label>Type de palette</label>
				<CInputRadioGroup inline :checked.sync="type" :options="typeOptions" name="type" />
			</CCol>
		</CRow>
		<CRow>
			<CInput type="hidden" name="flight" :value="`/api/flights/${this.$route.query['flight']}`" />
		</CRow>
		<CRow>
			<CCol>
				<CInput
					type="text"
					label="Limite poids"
					name="weightLimit"
					v-model="weightLimit"
					:description="
						remainingWeight != null ? `Il reste ${remainingWeight} kg disponible pour ce vol` : ''
					">
					<template #append-content> KG </template>
				</CInput>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<CInput
					type="text"
					label="Limite volume"
					name="volumeLimit"
					v-model="volumeLimit"
					:description="
						remainingVolume !== null
							? `Il reste ${remainingVolume} uv disponible pour ce vol`
							: ''
					">
					<template #append-content> UV </template>
				</CInput>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<CInput
					type="text"
					label="Limite quantité"
					name="quantityLimit"
					v-model="quantityLimit"
					:description="
						remainingQuantity !== null
							? `Il reste ${remainingQuantity} de quantité disponible pour ce vol`
							: ''
					">
					<template #append-content> Nb </template>
				</CInput>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	export default {
		props: {
			pallet: null | Object,
		},
		watch: {
			type: function (newVal) {
				this.weightLimit = '';
				this.volumeLimit = '';
				this.quantityLimit = '';
			},
		},
		data() {
			return {
				masks: {
					L: 'YYYY-MM-DD',
				},
				modelConfig: {
					type: 'string',
				},
				handoverTime: this.pallet
					? this.pallet.handoverTime
					: this.$moment().format('YYYY-MM-DD HH:mm'),
				type: this.pallet ? this.pallet.type : null,
				weightLimit: this.pallet ? this.pallet.weightLimit : null,
				volumeLimit: this.pallet ? this.pallet.volumeLimit : null,
				quantityLimit: this.pallet ? this.pallet.quantityLimit : null,
				remainingWeight: null,
				remainingVolume: null,
				remainingQuantity: null,
				typeOptions: [
					{ value: 'AKE', label: 'AKE' },
					{ value: 'PAL', label: 'PAL' },
					{ value: 'OTHER', label: 'Autre' },
				],
			};
		},
		methods: {
			getFlightRemainingSpace() {
				this.$axios
					.get(`/api/flights/${this.$route.query['flight']}/pallets/remainingspace`)
					.then(res => {
						if (res.status === 200) {
							this.remainingWeight = res.data['remainingWeight'];
							this.remainingVolume = res.data['remainingVolume'];
							this.remainingQuantity = res.data['remainingQuantity'];
						} else {
							this.$toast.error(
								"Une erreur s'est produite, certaines fonctionnalitées " +
									'peuvent ne pas fonctionner correctement, contactez un administrateur'
							);
						}
					});
			},
		},
		mounted() {
			this.getFlightRemainingSpace();
		},
	};
</script>
